/**
 * Copyright (c) Corinvo, LLC. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import * as DOM from './dom.json';
import * as NUMERIC from './numeric.json';
import * as CHARS from './characters.json';
import * as ALPHABET from './alphabet.json';

export { CHARS, ALPHABET, NUMERIC, DOM };
